import axios from 'axios';
import setAuthToken from '../utils/setAuthToken';
import {SIGNIN_URL} from './index';
import jwt_decode from 'jwt-decode';
import {SET_AUTH_USER, UNSET_USER} from '../stores/auth';
import errorHandler from "../utils/errorHandler";
import {getZones} from "./app";

//Login - Auth Token
export const loginUser = (payload) => {
    return function(dispatch) {
        return axios.post(SIGNIN_URL, payload).then((response) => {
            //Save to localStorage
            const { token } = response.data;

            //Set token to localStorage
            localStorage.setItem('jwtToken', token);

            //Set token to Auth header
            setAuthToken(token);

            //Decode token to get user data
            const decoded = jwt_decode(token);
            if(!response.error) {
                //Set current user
                dispatch(SET_AUTH_USER({user: decoded, isAuthenticated: true}));
            }
        }).catch((error) => {
            errorHandler(error, "top-center");
        });
    }
};

export const updateAuthToken = (data) => {
    return function(dispatch) {
        const { token } = data;
        localStorage.setItem('jwtToken', token);
        setAuthToken(token);
        const decoded = jwt_decode(token);
        dispatch(SET_AUTH_USER({user: decoded, isAuthenticated: true}));
        return true;
    }
};

export const logoutUser = () => {
    return function(dispatch) {
        //Remove toke from localStorage
        localStorage.clear();

        //Remove auth header for future requests
        setAuthToken(false);

        //Set current user to {} which will set isAuthenticated to false
        dispatch(UNSET_USER());
    }
};
